
const setTotalContato = (context,total) => {
	context.commit('SET_TOTAL_CONTATO', total);
}

const setTotalProcedimento = (context,total) => {
	context.commit('SET_TOTAL_PROCEDIMENTO', total);
}


const setCredenciada = (context,credenciada) => {
	context.commit('SET_CREDENCIADA', credenciada);
}

export{
	setTotalContato,
	setTotalProcedimento,
	setCredenciada
}



// WEBPACK FOOTER //
// ./src/store/credenciada/actions.js